module.exports = __webpack_public_path__ + "img/cca0ba1.jpg";